var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-content",style:(("width:" + _vm.width + "px;height:" + _vm.height + "px;"))},[_c('canvas',{ref:"pupilchart",attrs:{"width":_vm.width,"height":_vm.height}}),_vm._v(" "),_c('div',{ref:"tooltip",staticClass:"chart-content-tip"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594bc8e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/topography/components/PupilConeaChart.vue
// module id = null
// module chunks = 